import { render, staticRenderFns } from "./jiankong.vue?vue&type=template&id=0849bacf&"
import script from "./jiankong.vue?vue&type=script&lang=js&"
export * from "./jiankong.vue?vue&type=script&lang=js&"
import style0 from "./jiankong.vue?vue&type=style&index=0&id=0849bacf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports